import { render, staticRenderFns } from "./addNews.vue?vue&type=template&id=0f754cd0&scoped=true"
import script from "./addNews.vue?vue&type=script&lang=ts"
export * from "./addNews.vue?vue&type=script&lang=ts"
import style0 from "./addNews.vue?vue&type=style&index=0&id=0f754cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f754cd0",
  null
  
)

export default component.exports